import { createStaticReducer } from '../../utils/redux/createStaticReducer';

export const suburbanBuildersAccountsListReducer = createStaticReducer<Record<string, number>>({});
